module.exports = __webpack_public_path__ + "img/chad_chadtoken.gm.6ff1feb.png";